import { z } from 'zod'
import { FIELD_CANNOT_BE_EMPTY } from '../../../../../consts/validationErrors'

export const whatAvailableSchema = z.object({
    whatAvailable: z
        .array(
            z.object({
                title: z
                    .string({ required_error: FIELD_CANNOT_BE_EMPTY })
                    .trim()
                    .min(1, { message: FIELD_CANNOT_BE_EMPTY })
                    .min(2, { message: "Минимально 2 символа" })
                    .max(240, { message: "Максимально 240 символа" }),
                description: z
                    .string({ required_error: FIELD_CANNOT_BE_EMPTY })
                    .trim()
                    .min(1, { message: FIELD_CANNOT_BE_EMPTY })
                    .min(2, { message: "Минимально 2 символа" })
                    .max(240, { message: "Максимально 240 символа" }),
            })
        )
});
